import React, { useState, useEffect, useRef, useCallback } from 'react';
import heroBg from '../../images/photo-big-screen.jpg';

const ROLES = [
  'Web Developer',
  'Problem Solver',
  'Small Business Builder',
  'Hillsborough Local',
];

const TYPING_SPEED = 80;
const ERASE_SPEED  = 45;
const PAUSE_AFTER  = 1800;
const PAUSE_BEFORE = 400;

const Header = () => {
  const [displayed, setDisplayed] = useState('');
  const [roleIndex, setRoleIndex] = useState(0);
  const [isErasing, setIsErasing] = useState(false);
  const [clicked, setClicked] = useState(false);
  const glitchRef  = useRef(null);
  const glitchTimer = useRef(null);

  // typewriter
  useEffect(() => {
    const target = ROLES[roleIndex];
    if (!isErasing && displayed.length < target.length) {
      const t = setTimeout(() => setDisplayed(target.slice(0, displayed.length + 1)), TYPING_SPEED);
      return () => clearTimeout(t);
    }
    if (!isErasing && displayed.length === target.length) {
      const t = setTimeout(() => setIsErasing(true), PAUSE_AFTER);
      return () => clearTimeout(t);
    }
    if (isErasing && displayed.length > 0) {
      const t = setTimeout(() => setDisplayed(displayed.slice(0, -1)), ERASE_SPEED);
      return () => clearTimeout(t);
    }
    if (isErasing && displayed.length === 0) {
      const t = setTimeout(() => {
        setIsErasing(false);
        setRoleIndex((i) => (i + 1) % ROLES.length);
      }, PAUSE_BEFORE);
      return () => clearTimeout(t);
    }
  }, [displayed, isErasing, roleIndex]);

  const handleHeroClick = useCallback((e) => {
    if (e.target.closest('button')) return;
    setClicked(true);
    clearTimeout(glitchTimer.current);

    const el = glitchRef.current;
    if (!el) return;
    el.classList.remove('glitch');
    void el.offsetWidth; // force reflow to restart animation
    el.classList.add('glitch');

    glitchTimer.current = setTimeout(() => {
      glitchRef.current?.classList.remove('glitch');
    }, 500);
  }, []);

  return (
    <section
      id="hero"
      className="hero"
      onClick={handleHeroClick}
      style={{
        backgroundImage: `url(${heroBg})`,
        cursor: 'crosshair',
      }}
    >
      <div className="hero-photo-overlay" />
      <div className="hero-grid-bg" />
      <div className="hero-glow-1" />
      <div className="hero-glow-2" />

      <div className="hero-text-group" ref={glitchRef}>
        <p className="hero-eyebrow">Hillsborough, NC · Web Developer</p>
        <h1 className="hero-name">
          Taylor{' '}
          <span className="hero-name-accent">Guy</span>
        </h1>
        <p className="hero-role">
          <span className="hero-role-prefix">I'm a&nbsp;</span>
          <span className="typewriter-text">{displayed}</span>
          <span className="typewriter-cursor" />
        </p>
      </div>

      <div className="hero-cta">
        <button
          className="btn-primary"
          onClick={() => document.querySelector('#projects')?.scrollIntoView({ behavior: 'smooth' })}
        >
          View My Work ↓
        </button>
        <button
          className="btn-secondary"
          onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
        >
          Get In Touch
        </button>
      </div>

      {!clicked && (
        <p className="hero-click-hint">click anywhere ✦</p>
      )}

      <div className="scroll-hint">
        <div className="scroll-mouse" />
        <span>scroll</span>
      </div>
    </section>
  );
};

export default Header;
